import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DoubleLeft"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.2498 12L18.7498 19.5L19.7998 18.45L13.3498 12L19.7998 5.55L18.7498 4.5L11.2498 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.4998 12L11.9998 19.5L13.0498 18.45L6.5998 12L13.0498 5.55L11.9998 4.5L4.4998 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DoubleLeft.vue"]]);
